import {mapActions, mapGetters, mapMutations} from "vuex";
import Utils from "../components.utils.js"
import Constants from "../components.constants.js";
import {NotifierConstants} from "../components.constants.js";

const highlightMixin = {
    data(){
        return{
            selectedFileMimeType:"",
            showHiddenFields:false,
            assetId:null,
            hiddenFieldIdList:[],
            startupUserGroupList:[],
            tagMetadataScreenId:"",
            viewProfileSelection:false,
            displayAlwaysFieldsIdList:[],
            fetchedFieldIdList:[],
            fetchedTagIdList:[],
            metadataScreenInfo:{
                "field_id_list":[],
                "read_only_field_id_list":[],
                "mandatory_field_id_list":[],
                "display_always_field_id_list":[]
                },
            selectedRelaventProfileIdList:["All"],
            isLoaded:false,
            time:null,
            isTagsBrowse:false,
            time1:null,
            dateTime:null,
            lang: {
                formatLocale: {
                    firstDayOfWeek: 1,
                },
                monthBeforeYear: false,
                },
            timePickerOptions:{
                            start: '00:00',
                            step: '00:01',
                            end: '23:50'
                        },
            picklistValue:{},
            description: "",
            postData:{metadata:{}},
            viewfieldInfoIds:[],
            slugName:"",
            route:"",
            editingMetadataKeyInDock:null,
            assetCustomMetadata : {"custom_metadata":[]},
            customMetadataList: [],
            metadataProfileList:[],
            tagNamesList:[],
            selectedTags: [],
            editingCustomMetadata : {},
            cutomMetadatavalue:null,
            categoryDetails:[],
            selectedCatParentIdList:[],
            postcatalogKey:"parent_id_path",
            selectedCatParentIdPathList:[],
            categoryName:"",
            autoCompleteCatOptionsList:[],
            categoryListFromAutocomplete:[],
            tagsListFromAutocomplete:[],
            selectedTagIdList:[],
            selectedTagIdNameMapper:{},
            cacheTagIdList:[],
            customMetadataCheck:null,
            customMapper:{},
            assetDetails:{},
            singlePickListMapper:{},
            pickListMapper:{},
            isCustomMetadataFieldsModified:false,
            isNewTagsAdded:false,
            actionsOnPlayer: false,
            audioUrl:null,
            controller:{},
            selectedProfile:[],
            subclipsList:[],
            videoOptions: {
                autoplay: true,
                controls: true,
                nativeTextTracks: true,
                controlBar:{
                    'pictureInPictureToggle': false,
                },
                        sources: []
                    },
            profileDetails:{
                "display_description":0,
                "custom_metadata_display_config":0,
                "tag_display_config": 0,
                "tag_displayall_config":0,
                "custom_metadata_id_list":[],
                "custom_metadata_allId_list":0,
                "tag_id_list":[]
            },
            relevantProfilesList:[],
            checkedProfiles:[],
            assetUpdatedThroughNotification:false,
            isSubclipEnabled:false,
            subclipsRowsStyles:{
                slugFontSize:{"font-size":"16px"},
                duration:{"font-size":"15px"},
                image:{"width":"130px"}
            },
            page:1,
            totalSubclipsPages:-1,
            activeSubclipPreview:'',
            showSubclips:true,
            showMetadata:true,
            showSystemDefinedMetadata:true,
            openShareInChat:false,
            assetDetailsOfSubclip:{},
            showTranscriptHighlight: true,
            transcriptPlayingUid:null,
            showFaceDetectionHighlight: true,
            showOCRHighlight:true,
            showObdDetection:true,
            showAdvanceMetadata:true,
            highlightRegex: null,
            globalSearchText:null,
            onePxWidthValue:0,
            onePxHeightValue:0,
            imageActualLeft:0,
            imageActualTop:0,
            isFaceObjImageLoaded: false,
            selectedFileInfo:{},
            openPip:false,
            showOtherFilesPreviewDialog:false,
            departmentsList:[],
            selectedDepartments:null,
            referenceID:'',
            isJobCompleted:false,
            isJobInitialted:false,
            progressValue:0,
            updatedAssetsCount:0,
            isJobFailed:false,
            errorMessage:"",
            jobId:"",
            totalAssetsCount:0,
            loadingGif:Utils.getLoadingGif(),
            showLoadingGif:false,
            isMiniPlayerVisible:false,
            transcriptPlayObject:{},
            playSubclipObject:{},
        };
    },

    computed:{
        globalSettingsFromStartup:{
            get(){
                return this.$store.state.startUpData.startUpDataDetails;
            }
        },
        isTypeCatalog(){
            try {
                if('asset_type' in this.assetDetails){
                    return ["catalog"].includes(this.assetDetails.asset_type)
                }
            } catch (err) {
                console.error(`[isTypeCatalog][folder][Error while checking folderType-${err}]`)
            }
            return false
        },
        getMimeType(){
            try{
                return Utils.getFileMediaType(this.assetDetailsFromParent);
            }catch(e){
                console.log(e);
            }
            return '';
        },
        confirmedFaceObjects(){
            let objects = []
            this.assetDetailsFromParent.ai_info.face_detection.forEach(obj => {
                let matchingGroup = objects.find(group => group.every(item=>item.mark_in === obj.mark_in &&
                                                                                        item.media_out === obj.media_out &&
                                                                                        item.status === "confirmed" &&
                                                                                        item.name && item.name.trim().length > 0));
                if(obj.status === "confirmed"){
                    if (matchingGroup) {
                        matchingGroup.push(obj);
                    } else {
                        objects.push([obj]);
                    }
                }
            });
            return objects;
        },
        confirmedOBDObjects(){
            let objects = []
            this.assetDetailsFromParent.ai_info.obd.forEach(obj => {
                let matchingGroup = objects.find(group => group.every(item=>item.mark_in === obj.mark_in &&
                                                                                        item.media_out === obj.media_out &&
                                                                                        item.status === "confirmed" &&
                                                                                        item.name && item.name.trim().length > 0));
                if(obj.status === "confirmed"){
                    if (matchingGroup) {
                        matchingGroup.push(obj);
                    } else {
                        objects.push([obj]);
                    }
                }
            });
            return objects;
        },
        ...mapGetters("users",["getLoggedInUserId","getLoggedInUserPrivilege","getIsAssetsDetailsPanelVisible"]),
        ...mapGetters('pluginRepo',["getInstalledPluginsData"])
    },

    watch:{
        immediate:true,
        deep:true,
        assetDetailsFromParent(newVal,oldVal){
            if(oldVal != newVal){
                this.activeSubclipPreview = '';
                this.refreshStartData("user_groups");
                this.refreshStartData("metadata_profiles");
                this.refreshStartData('custom_metadatas');
                this.refreshStartData("screens");
                this.isLoaded=false;
                if(this.assetDetailsFromParent != undefined){
                  this.refreshFileInfoAndShowAsset(this.assetDetailsFromParent) 
                }
                this.selectedFilter = 'Metadata';
                if(this.$refs['metadataDockUl']){
                  this.$refs['metadataDockUl'].scrollTop = 0;
                }
            }
        },
        enableSubclip(newVal){
            if(newVal){
                this.isSubclipEnabled = true;
            }else{
                this.isSubclipEnabled = false;
            }
        },
        openPip(newVal){
            console.log("openPip openPip",newVal);
            if(newVal){
                this.isMiniPlayerVisible = false;
            }
        },
        isMiniPlayerVisible(newVal){
          console.log("isMiniPlayerVisible isMiniPlayerVisible",newVal);
          if(newVal){
              this.openPip = false;
          }
        }
    },
    methods:{
        isChildExists(parentInfo){
          let childPresent = false
          this.customMetadataList.filter(obj=>{
            if('load_when' in obj && obj.load_when.find(op=>op.id == parentInfo._id)){
              childPresent =  true;
              return childPresent
            }
        })
          return childPresent
        },
        getHierarchyMetadata(parentInfo){
            let items = this.customMetadataList.filter(obj => obj.load_when)
            items.push(parentInfo)
            let map = {};
            let roots = [];
      
            // Create a map of items with their IDs
            items.forEach(item => {
                map[item._id] = { ...item, children: [] };
            });
            // Build the hierarchy
            items.forEach(item => {
                if (item.load_when && item.load_when.length) {
                    item.load_when.forEach(condition => {
                        let parent = map[condition.id];
                        if (parent) {
                            let isFieldValueMatched = false;
                            let exp = item.load_when.find(op=>op.id == condition.id);
                            if(exp){
                              
                              if(Array.isArray(exp.value) && exp.value.length == 0){
                                  isFieldValueMatched = true
                              }else if(Object.keys(exp.value).length == 0){
                                  isFieldValueMatched = true
                              }else{
                                  // If parent expression is added,  then validate
                                  let fieldEntryDetails = this.assetDetails["custom_metadata"].find(item=>item.key_id == condition.id);
                                  if(fieldEntryDetails){
                                      if(["FREETEXT","FREETEXT_MULTILINE"].includes(exp.type)){
                                          if(exp.value == fieldEntryDetails.value[0]){
                                              isFieldValueMatched = true;
                                          }
                                      }else if(["DATE"].includes(exp.type)){
                                          let fieldDate = fieldEntryDetails.value[0];
                                          let fromDate = exp.value[0];
                                          let toDate = exp.value[1];
                                          if(fromDate <= fieldDate && fieldDate <= toDate){
                                              isFieldValueMatched = true;
                                          }
                                      }else if(["DATE_TIME"].includes(exp.type)){
                                          let fieldDate = fieldEntryDetails.value[0];
                                          fieldDate = fieldDate.replace("T"," ");
                                          let fromDate = exp.value[0];
                                          fromDate = fromDate.replace("T", " ")
                                          let toDate = exp.value[1];
                                          toDate = toDate.replace("T"," ");
                                          if(fromDate <= fieldDate && fieldDate <= toDate){
                                              isFieldValueMatched = true;
                                          }
                                      }else if(["INTEGER"].includes(exp.type)){
                                          if(fieldEntryDetails.value[0] >= exp.value["from"] && fieldEntryDetails.value[0] <= exp.value["to"]){
                                              isFieldValueMatched = true;
                                          }
                                      }else if(["PICKLIST","PICKLIST_MULTIVALUE"].includes(exp.type)){
                                          for(let val of exp.value){
                                              if(!fieldEntryDetails.value.includes(val)){
                                                  isFieldValueMatched = false;
                                                  break;
                                              }
                                              isFieldValueMatched = true;
                                          }
                                      }
                                  }
                              }
                              if(isFieldValueMatched){
                                  parent.children.push(map[item._id]);
                              }
                            }
                        }
                    });
                } else {
                    roots.push(map[item._id]);
                }
            });
            let matchedHM =  roots.filter(op=>op._id == parentInfo._id);
            if(matchedHM.length > 0){
              return [matchedHM[0]]
            }
            console.log("****************************** ", parentInfo.name , matchedHM)
            return matchedHM;
        },
        getCustomMetadataName(fieldInfo){
            if('language_alias_mapper' in fieldInfo && fieldInfo.language_alias_mapper && fieldInfo.language_alias_mapper.length > 0 && this.$i18n && this.$i18n.locale){
                let mapperExists = fieldInfo.language_alias_mapper.find(op=>op.code == this.$i18n.locale)
                if(mapperExists && Object.keys(mapperExists).length > 0 && mapperExists.field_alias && mapperExists.field_alias.length > 0){
                    return mapperExists.field_alias;
                }
            }
            return fieldInfo.name;
        },
        updateSelectedDepartments(value){
            this.selectedDepartments = value;
        },
        picPicZindex(zvalue, ref){
            if(this.$refs[ref].$el.style)this.$refs[ref].$el.style.cssText += `z-index:${zvalue} !important`
        },
        showAssetDetailsDockCloseMiniplayer(){
            if(this.showOtherFilesPreviewDialog) this.showOtherFilesPreviewDialog = false;
            this.openPip = true;
        },
        showAssetDetailsDockCloseMaximisedplayer(){
            if(this.isFullscreenPreviewAllowed()){
                this.openPip = false;
                this.showOtherFilesPreviewDialog = true;
                return;
            }
        },
        openPictureInPicture(){
            if(this.isFullscreenPreviewAllowed()){
                this.openPip = false;
                this.showOtherFilesPreviewDialog = true;
                return;
            }else{
                this.openPip = true;
                this.showOtherFilesPreviewDialog = false;
            }
        },
        isFullscreenPreviewAllowed(){
            let allowedFullScreenPreview = ['image',...Constants.supportedDocumentPreviewList,...Constants.supported3dModelPreviewList];
            return allowedFullScreenPreview.indexOf(Utils.getFileMediaType(this.selectedFileInfo)) > -1
        },
        previewProxy(fileInfo){
            this.selectedFileInfo = {};
            this.selectedFileInfo = fileInfo;
            this.$nextTick(() => {
                this.openPictureInPicture()
            })
        },
        closeMinimisedPlayer(){
            this.openPip = false;
            this.showOtherFilesPreviewDialog = false;
        },
        isPluginInstalled(pluginName){
            if(this.getInstalledPluginsData){
                let indx = this.getInstalledPluginsData.findIndex(e => e.plugin_name.toLowerCase() == pluginName.toLowerCase())
                if(indx > -1){
                    return true;
                }
            }
            return false;
        },
        style(name){
            let style = {
                'color':Utils.textColor(Utils.intToRGB(Utils.hashCode(name))),
                'background-color':'#'+Utils.intToRGB(Utils.hashCode(name))
            }
            return style
        },
      
        checkProfileImageExist(profileObjId){
            let profileImage = "";
            if('personality_info' in this.assetDetailsFromParent && this.assetDetailsFromParent.personality_info.length>0){
                let personalityInfo = this.assetDetailsFromParent.personality_info;
                let personalityObjIndex = personalityInfo.findIndex((obj)=>obj._id == profileObjId);
                if (personalityObjIndex>=0){
                    if('profile_image' in personalityInfo[personalityObjIndex] && personalityInfo[personalityObjIndex].profile_image){
                        profileImage = personalityInfo[personalityObjIndex].profile_image;
                    }
                }
            }
            return profileImage;
        },
        imagesLoadedCallback(event){    
            console.log(`[imagesLoadedCallback]`,event.target.getBoundingClientRect());
            let widthHeightRatio = event.target.naturalWidth/event.target.naturalHeight;
            let maxAllowedWidth = 120, maxAllowedHeight = 400;
            let newWidth = maxAllowedWidth;
            let newHeight = newWidth/widthHeightRatio;
            if (newHeight > maxAllowedHeight) {
                newHeight = maxAllowedHeight;
                newWidth = newHeight * widthHeightRatio;
            }
    
            event.target.style.width = newWidth +'px';
            event.target.style.height = newHeight +'px';
    
            this.$nextTick(()=>{
                let proxyWidth = newWidth;
                let proxyHeight = newHeight;
                this.onePxWidthValue = 1*(event.target.naturalWidth/proxyWidth);
                this.onePxHeightValue = 1*(event.target.naturalHeight/proxyHeight);
                this.imageActualLeft = event.target.offsetLeft;
                this.imageActualTop = event.target.offsetTop;
                this.isFaceObjImageLoaded = true;
            });
        },
        getglobalSearchedValue(){
            return this.$parent.globalSearchedValue;
        },
        highlightTranscript(transcriptText) {
            let searchValue = this.$parent.globalSearchedValue;
            searchValue = String(searchValue);
            if (!searchValue) return transcriptText;
            try{
                var keywordList = searchValue.match(/[^\s"]+|"[^"]+"/g).map(x => x.replace(/"/g, ''));
                keywordList.sort((a, b) => b.length - a.length);
                var filteredKeywordList = [];
                for(var i = 0; i < keywordList.length; i++){
                  if(String(keywordList[i]).trim() != ''){ 
                      var eachKeyword = keywordList[i];
                      filteredKeywordList.push(eachKeyword+'\\w*');   
                  }
                }
                var pattern = new RegExp(String.raw`(?<=[(["\s]|^)(${filteredKeywordList.join("|")})[^\]\s)"]*`, 'igm');
                var textDescription = transcriptText.replace(pattern, `<font color="OrangeRed">$&</font>`);
                return textDescription;
            }catch(e){
                console.log('error',e);
                return transcriptText;
            }
        },
          playTranscript(transcript){
            this.$emit("setTranscriptData",transcript);
            try{
               this.playSubclipObject = {};
               this.transcriptPlayObject = transcript;
              //  if(this.isMetadataDock){
              //   this.isMiniPlayerVisible = true;
              //  }
            }catch(e){console.log(e)}
            this.activeSubclipPreview = '';
            try{
              this.$parent.$attrs.playVideoOnOpen(transcript,true,()=>{
                console.log('video playing.......');
              });
            }catch(error){
              try{
                  this.$parent.removeTimeLineMarkers();
                 }catch(e){console.log(e)}
              this.$parent.$refs.videoPlayerRef.player.currentTime(transcript.media_in/1000);
              this.$parent.$refs.videoPlayerRef.player.play();
                console.log('video playing.......')
            }
      
          },
          getDurationFormatAsHHorMMSS(duration){
             return Utils.getDurationInHHorMMSS(duration / 1000);
          },
          deleteSelectedSubclip(id){
            if(confirm(
                `Are you sure you want to delete selected subclip?`
              )){
                let payload = {};
                payload = {_id: id}
                  this.deleteSubclip(payload).then((data) => {
                    if(!Utils.isAcceptedStatusCode(data.statusCode)){
                          this.$toast.error(data.message);
                    }else{
                      this.$toast.success(data.message);
                      this.subclipsList = this.subclipsList.filter(e => e._id != id)
                    }
                })
              }
          },
          closeShareInChat(){
            this.openShareInChat = false;
          },
          sortTranscriptBasedOnTime(arr = []){
            return arr.sort((a,b)=>{
              if (a.media_in !== b.media_in) {
                return a.media_in - b.media_in;
              } else {
                return a.media_out - b.media_out;
              }
            });
          },
          async loadTranscript(subclip){
            let data = await this.getSubclipTransctiptFromServer({params:{asset_id:subclip.asset_id, asset_type:'subclip'}})
            let indx = this.subclipsList.findIndex(op=>op.asset_id == subclip.asset_id)
            if(indx >= 0){
              if(data.transcript){
                this.$set(this.subclipsList[indx], 'transcript', this.sortTranscriptBasedOnTime(data.transcript.transcript))
              }else{
                this.$set(this.subclipsList[indx], 'transcript', [])
              }
            }
          },
          handleShareAction(clip){
            this.assetDetailsOfSubclip = clip;
            this.openShareInChat = true;
          },
          isEnabled(priv) {
            return Utils.isPrivilegeEnabled(this.getLoggedInUserPrivilege, priv);
          },
          getCatParentName(catalogInfo){
            if('parent_path' in catalogInfo){
              return catalogInfo.parent_path["value"]
            }
            return ""
          },
          resetEditMode(){
            this.editingMetadataKeyInDock = null
          },
          previewSubclipMarkinMarkout(subclip){
           /*   alert('im here..');
             let markin = subclip.markers.start;
             let markout = subclip.markers.end;
             if(markin && isNaN(Number(markin))) markin = Utils.hhmmssToMs(markin);
             if(markout && isNaN(Number(markout))) markout = Utils.hhmmssToMs(markout); */
             this.activeSubclipPreview = String(subclip._id);
             this.$emit('playSubclipMarkinMarkout',subclip);
            //  if(this.getIsAssetsDetailsPanelVisible)
               if(this.$parent && this.$parent.$parent) this.$parent.$parent.$emit('playSubclipMarkinMarkout',subclip,true);
          },
          isMetadataPrivEnabled(){
            let filePermission = false;
            if(["full-control","read-write","read-modify"].includes(this.assetDetailsFromParent.permissions)){
              filePermission = true;
            }
            return (Utils.isPrivilegeEnabled(this.getLoggedInUserPrivilege, "tag-metadata") && filePermission)
            // return (Utils.isPrivilegeEnabled(this.getLoggedInUserPrivilege, "tag-metadata"))
          },
          isAIPrivilegeEnabled(priv, isTranscript=false){
            let filePermission = false;
            if(isTranscript && ["full-control","read-write","read-modify", "read"].includes(this.assetDetailsFromParent.permissions)){
              filePermission = true
            }else if(["full-control","read-write","read-modify"].includes(this.assetDetailsFromParent.permissions)){
              filePermission = true;
            }
            return (Utils.isPrivilegeEnabled(this.getLoggedInUserPrivilege,priv) && filePermission)
          },
          enterSubclipEditSection(selectedSubclip,compType, view){
            let subComponentName = '';
            if(compType == 'media-edit'){
              subComponentName = this.$route.params.subComponentToBeUsed && this.$route.params.subComponentToBeUsed['mediaedit-component']?this.$route.params.subComponentToBeUsed['mediaedit-component']:'explorer'
            }else if(compType == 'subclips'){
              subComponentName = this.$route.params.subComponentToBeUsed && this.$route.params.subComponentToBeUsed['subclip-component']?this.$route.params.subComponentToBeUsed['subclip-component']:'explorer'
            }
            if(view && view == 'metadataView'){
                if(this.parentComponent && this.parentComponent == 'tagMetadataFullScreen'){
                  this.$emit("openSubclipWindow",selectedSubclip,subComponentName,compType);
                }else{
                  this.$emit("openSubclipWindowInMetadataView",selectedSubclip,subComponentName,compType);
                }
            }else{
              this.$emit("openSubclipWindow",selectedSubclip,subComponentName,compType);
            }
          },
          editTranscript(subclip){
            let subComponentName = this.$route.params.subComponentToBeUsed && this.$route.params.subComponentToBeUsed['asset-video-transcript']?this.$route.params.subComponentToBeUsed['asset-video-transcript']:'explorer'
            this.$emit("openSubclipWindow",subclip,subComponentName, "transcript");
          },
          customLabelPicklistSingleVal(option){
            return `${option}`
          },
            getSelectedProfileName(rpId){
              let profileInfo = this.relevantProfilesList.filter((STemplate)=>STemplate.metadata_profile_id == rpId);
              if(profileInfo.length > 0){
                return profileInfo[0].name;
              }
              return "";
            },
            removeSelectedOption(option){
              this.checkedProfiles = this.checkedProfiles.filter(e => e.metadata_profile_id != option.metadata_profile_id)
              this.removeProfile(option);
            },
            handleHiddenFieldsView(e){
              console.log(e); //
              e.preventDefault(); // prevent default behaviour of reload
              this.showHiddenFields = true;
              // if(this.hiddenFieldIdList != undefined && this.hiddenFieldIdList.length > 0){
              //   for(let eId of this.hiddenFieldIdList){
              //     if(!this.metadataScreenInfo["field_id_list"].includes(eId)){
              //       this.metadataScreenInfo["field_id_list"].push(eId);
              //     }
              //   }
              // }
              this.hiddenFieldIdList = [];
              this.selectedRelaventProfileIdList.push('All');
            },
            updateFieldsView(){
                this.profileDetails = {
                  "display_description":0,
                  "custom_metadata_display_config":0,
                  "tag_display_config":0,
                  "tag_displayall_config":0,
                  "custom_metadata_id_list":[],
                  "custom_metadata_allId_list":0,
                  "tag_id_list":[]
                },
                this.fetchedFieldIdList = [];
                this.fetchedTagIdList = [];
                if(this.selectedRelaventProfileIdList != undefined && this.selectedRelaventProfileIdList.length > 0){
                  for(let i= 0; i<this.selectedRelaventProfileIdList.length;i++){
                    if(this.selectedRelaventProfileIdList[i] == 'All'){
                      this.fetchedFieldIdList.concat(this.metadataScreenInfo.field_id_list)
                    }
                    let STemplateDetails = this.metadataProfileList.filter((STemplate)=>STemplate._id == this.selectedRelaventProfileIdList[i]);
                    if(typeof STemplateDetails != "undefined" && STemplateDetails.length > 0){
                      let profileDetail = {};
                      Object.assign(profileDetail,STemplateDetails[0]);
      
                      //profile fields count
                      if(profileDetail.custom_metadata_id_list != undefined && profileDetail.custom_metadata_id_list.length > 0){
                        this.profileDetails.custom_metadata_display_config = this.profileDetails.custom_metadata_display_config + 1;
                      }
                      //profile tags
                      if(profileDetail.tag_display_all == true){
                        this.profileDetails.tag_displayall_config = this.profileDetails.tag_displayall_config + 1;
                      }else if(profileDetail.tag_id_list != undefined && profileDetail.tag_id_list.length > 0){
                        this.profileDetails.tag_display_config = this.profileDetails.tag_display_config + 1;
                      }
                      if(typeof profileDetail.tag_id_list != "undefined" && profileDetail.tag_id_list.length > 0){
                        let tagList = [];
                        Object.assign(tagList, profileDetail.tag_id_list);
                        for(let tag of profileDetail.tag_id_list){
                          if(!this.fetchedTagIdList.includes(tag)){
                            this.fetchedTagIdList.push(tag);
                          }
                        }
                      }
                      this.fetchedTagIdList.concat(profileDetail.tag_id_list);
      
                      //profile fields
                      let idList = profileDetail.custom_metadata_id_list;
                      for(let fId of idList){
                        if(this.fetchedFieldIdList.indexOf(fId) == -1 &&
                          this.displayAlwaysFieldsIdList.indexOf(fId) == -1){
                            this.fetchedFieldIdList.push(fId);
                        }else if(!this.hiddenFieldIdList.includes(fId)){
                          this.hiddenFieldIdList.push(fId);
                        }
                        if(!this.metadataScreenInfo.field_id_list.includes(fId) && !this.hiddenFieldIdList.includes(fId)){
                          this.hiddenFieldIdList.push(fId);
                        }
                      }
                    }
                  }
                  for(let sId of this.metadataScreenInfo.field_id_list){
                    if(![undefined, null].includes(this.checkedProfiles) && this.checkedProfiles.length > 0 &&
                       !this.fetchedFieldIdList.includes(sId) && !this.hiddenFieldIdList.includes(sId) &&
                       !this.displayAlwaysFieldsIdList.includes(sId)){
                      this.hiddenFieldIdList.push(sId);
                    }
                  }
                }else{
                  this.hiddenFieldIdList = this.metadataScreenInfo.field_id_list;
                }
            },
            checkContext(){
              if(this.$route.name && this.$route.name == 'tag-metadata-media-pipeline'){
                return false;
              }
              return true;
            },
            screenProfileLabelCallback(option){
              return this.getSelectedProfileName(option.metadata_profile_id)
            },
            selectionLabelCallback(option){
                if(option.catalog_name != undefined){
                  return `${option.catalog_name}`
                }
            },
            picklistCheckFunc(option,id){
              this.singlePickListMapper[id] = option;
              this.saveFields('custom_metadata', (this.metadataScreenInfo.mandatory_field_id_list != undefined && this.metadataScreenInfo.mandatory_field_id_list.includes(id)))
            },
            selectProfile(option){
              if(this.selectedRelaventProfileIdList.length ==1 &&
                this.selectedRelaventProfileIdList.includes('All')){
                this.selectedRelaventProfileIdList.splice(this.selectedRelaventProfileIdList.indexOf('All'),1);
              }
              if(!this.selectedRelaventProfileIdList.includes(option.metadata_profile_id)){
                this.selectedRelaventProfileIdList.push(option.metadata_profile_id);
                let index = this.relevantProfilesList.findIndex(item => item.metadata_profile_id == option.metadata_profile_id);
                if(index > -1){
                    this.relevantProfilesList[index].checked = true;
                }
                let STemplateDetails = this.metadataProfileList.filter((STemplate)=>STemplate._id == option.metadata_profile_id);
                if(typeof STemplateDetails != "undefined" && STemplateDetails.length > 0){
                  for(let pFKey of STemplateDetails[0].custom_metadata_id_list){
                    if(!this.metadataScreenInfo["field_id_list"].includes(pFKey) && !this.hiddenFieldIdList.includes(pFKey)){
                      this.hiddenFieldIdList.push(pFKey);
                    }
                  }
                }
              }
              if(this.selectedRelaventProfileIdList.length <= 0){
                this.selectedRelaventProfileIdList.push('All');
              }
              this.updateFieldsView();
            }, 
            removeProfile(option){
              let index = this.checkedProfiles.findIndex(item => item.metadata_profile_id == option.metadata_profile_id);
              if(index > -1){
                  this.checkedProfiles[index].checked = false;
              }
              this.selectedRelaventProfileIdList.splice(this.selectedRelaventProfileIdList.indexOf(option.metadata_profile_id),1);
              let STemplateDetails = this.metadataProfileList.filter((STemplate)=>STemplate._id == option.metadata_profile_id);
              if(typeof STemplateDetails != "undefined" && STemplateDetails.length > 0){
                for(let pFKey of STemplateDetails[0].custom_metadata_id_list){
                  // if(this.metadataScreenInfo["field_id_list"].includes(pFKey)){
                  //   this.metadataScreenInfo["field_id_list"].splice(this.metadataScreenInfo["field_id_list"].indexOf(pFKey),1);
                  // }
                  if(this.hiddenFieldIdList.includes(pFKey)){
                    this.hiddenFieldIdList.splice(this.hiddenFieldIdList.indexOf(pFKey),1);
                  }
                }
              }
              if(this.selectedRelaventProfileIdList.length <= 0){
                this.selectedRelaventProfileIdList.push('All');
              }
              this.updateFieldsView();
            },
            makeProfileCheckBoxSelection(option){
                return this.checkedProfiles.some((op) => op.metadata_profile_id === option.metadata_profile_id);
            },
            getTagIds(){
              this.selectedTags = [];
              if("tag_info" in this.assetDetails){
                let tempList = [];
                tempList = Object.assign(tempList,this.assetDetails.tag_info);
                for (let tag=0;tag<tempList.length;tag++){
                  this.selectedTags.push({"_id":tempList[tag].tag_id,"name":tempList[tag].name})
                }
                this.cacheTagIdList = this.selectedTags;
              }
            },
            displayOptionsOnSearch(searchedKey){
              let payload = {};
              payload.params = {name:searchedKey};
              this.getAutoCompletedAssetsFromServer(payload).then((data)=>{
                this.$nextTick(()=>{
                  this.autoCompleteCatOptionsList = data.categories;
                })
              });
            },
            updatedCatalogsListComp(option){
              let newVal = option.parent_id_path + "/" + option._id
              if(this.globalSettingsFromStartup && this.globalSettingsFromStartup.enable_multi_catalog_browse){
                if(!this.selectedCatParentIdList.includes(newVal)){
                  this.selectedCatParentIdList.push(newVal);
                }
              }else{
                this.selectedCatParentIdList = [newVal]
              }
            },
            removedCatalogFromList(option){
              if(this.selectedCatParentIdList.includes(option.parent_id_path + "/" + option._id)){
                this.selectedCatParentIdList = this.selectedCatParentIdList.filter(op=>op != (option.parent_id_path + "/" + option._id));
              }
            },
            tagsLabelCallback(option){
                return `${option.name}`
            },
            removeSelectedTagOption(option){
              this.selectedTags = this.selectedTags.filter(e => e._id != option._id);
            },
            removeSelectedPicklistOption(option,id){
              this.pickListMapper[id] = this.pickListMapper[id].filter(e => e != option);
              this.saveFields('custom_metadata', (this.metadataScreenInfo.mandatory_field_id_list != undefined && this.metadataScreenInfo.mandatory_field_id_list.includes(id)));
            },
            getTagNamesFromServer(){
                this.getAllTagsFromServer().then((data) => {
                  this.tagsListFromAutocomplete = data.tags;
                });
            },
            getTagsOnKeyup(searchedKey){
                  let payload = {};
                  // if(query.length > 0 && query != undefined){
                    payload.params = {name:searchedKey};
                    this.getTagsOnAutocomplete(payload).then((data)=>{
                      this.tagsListFromAutocomplete = data.tags;
                    });
                  // }            
            },
            selectTags(option){
              let index = this.tagsListFromAutocomplete.findIndex(item => item._id == option._id);
                  if(index > -1){
                      this.tagsListFromAutocomplete[index].checked = true;
                  }
            },
            removeTags(option){
                let index = this.selectedTags.findIndex(item => item._id == option._id);
                if(index > -1){
                    this.selectedTags[index].checked = false;
                }
            },
            selectPicklist(option,values){
              let index = values.findIndex(item => item == option);
              if(index > -1){
                  values[index].checked = true;
                  values.push(option)
              }
            },
            removePicklist(option,selectedValues){
              let index = selectedValues.findIndex(item => item._id == option._id);
                if(index > -1){
                    selectedValues[index].checked = false;
                    selectedValues = selectedValues.filter(e => e != option)
                }
            },
            makeTagsCheckBoxSelection(option){
                return this.selectedTags.some((op) => op._id === option._id);
            },
            makePicklistCheckBoxSelection(option,id){
              if(this.pickListMapper[id] != undefined){
                return this.pickListMapper[id].some((op) => op.value_id === option.value_id);
              }
            },
            checkDuplicateTag(tagId){
              if(this.tagNamesList.length){
                for(let i = 0; i < this.tagNamesList.length; i++){
                    return this.tagNamesList[i].checkDuplicateTag != tagId;
                }
              }else{
                return false
              }
            },
            deleTagIdFromList(tagId){
              this.selectedTags = this.selectedTags.filter(e => e._id != tagId)
            },
            getFileName(fileInfo){
              return fileInfo.file_name?fileInfo.file_name:fileInfo.slug_name
            },
            getFilePath(fileInfo){
              if ("path" in fileInfo){
                  return fileInfo.path
              }else{
                  return this.getCategoryRoutefromId(fileInfo.category_id)
              }
            },
              picklistTypeCheck(custommetadata){
                let res =  custommetadata.type == 'PICKLIST_MULTIVALUE';
                if(res){
                  if(!(custommetadata._id in this.pickListMapper)){
                    this.pickListMapper[custommetadata._id] = this.getCustomMetadataValue(custommetadata._id, true)
                  }
                }
                return res
              },
              getSinglePicklistVal(id){
                if(this.singlePickListMapper != undefined && this.singlePickListMapper[id] != undefined){
                  return this.singlePickListMapper[id].value;
                }
                return "";
              },
              getAssetDateTimeValue(cMDEntry){
                let rDT = ""
                if(cMDEntry.type == "DATE"){
                  rDT = this.customMapper[cMDEntry._id]
                }else{
                  rDT = this.customMapper[cMDEntry._id]
                  if(rDT){
                    rDT = rDT.replace("T",  " ")
                  }
                }
                return rDT
              },
              getCustomMetadataValue(id, multiValues=false){
                   if(Object.keys(this.assetCustomMetadata).includes("custom_metadata")){
                      let cmdata = this.assetCustomMetadata.custom_metadata.filter((cdata)=>cdata.key_id == id)[0];
                      if(cmdata){
                        if(cmdata.value.length > 1 && !multiValues){
                          this.postData.cutomMetadatavalue = cmdata.value
                          return cmdata.value;
                        }else if(multiValues){
                          return cmdata.value
                        }else if(["DATE_TIME"].includes(cmdata.type)){
                          let cVal = cmdata.value[0];
                          cVal = cVal.replace("T", " ");
                          return cVal;
                        }else{
                          this.postData.cutomMetadatavalue = cmdata.value[0]
                          return cmdata.value[0];
                        }
                      }
                  }else{
                      this.postData.cutomMetadatavalue = ""
                      return ""
                  }
                },
              isFieldDescriptionEnabled(fieldId){
                if(this.viewfieldInfoIds.indexOf(fieldId) == -1){
                  return false;
                }else{
                  return true;
                }
              },
              enableOrDisableFieldInfo(fieldId){
                if(this.viewfieldInfoIds.indexOf(fieldId) == -1){
                  this.viewfieldInfoIds.push(fieldId);
                }
                else{
                  this.viewfieldInfoIds.splice(this.viewfieldInfoIds.indexOf(fieldId),1);
                }
              },
              isMetadataEdit(keyName) {
                  // this.categoryListFromAutocomplete = [];
                  return keyName === this.editingMetadataKeyInDock;
              },
              getSinglePicklistOptions(cMValues){
                let options = cMValues;
                let indx = options.findIndex(op=>op.value_id == null)
                if(indx < 0){
                  options.unshift({"value":" -- Select -- ","value_id":null})
                }
                return options
              },
              editMetadataDockFields(keyName, custMetadataKey=null, custMetadataType=null, custMetadataMultivalue=false) {
                if(['ai_face_detection','ai_transcript','ai_obd','ai_ocr'].includes(keyName)){
                  this.$emit("navigateToAIComponent", keyName)
                  this.editingMetadataKeyInDock = null
                  return
                }
                  if(!this.isMetadataPrivEnabled()){
                    return;
                  }
                  if(custMetadataType == "DATE"){
                    this.time1 = this.customMapper[custMetadataKey]
                  }else if(custMetadataType == "DATE_TIME"){
                    let vDT = this.customMapper[custMetadataKey]
                    if(vDT){
                      this.dateTime = vDT.replace("T", " ")
                    }else{
                      this.dateTime = ""
                    }
                  }
                  this.editingMetadataKeyInDock = keyName;
                  this.postData.cutomMetadatavalue = this.getCustomMetadataValue(custMetadataKey)
                  if (custMetadataKey != null && custMetadataType != null){
                      this.editingCustomMetadata = {"_id":custMetadataKey, "type": custMetadataType, "multi_values": custMetadataMultivalue}
                  } 
                  this.autoFocusInputFields(keyName,custMetadataType);
              },
              editMetadataOnDoubleclick(keyName, custMetadataKey=null, custMetadataType=null, custMetadataMultivalue=false){
                if(["slug_name","category"].includes(keyName) && this.isTypeCatalog){
                  return;
                }
                if(!this.isMetadataPrivEnabled() ||
                  (this.metadataScreenInfo.read_only_field_id_list != undefined &&
                  this.metadataScreenInfo.read_only_field_id_list.includes(custMetadataKey))){
                  return;
                }
                if(custMetadataType == "DATE"){
                  this.time1 = this.customMapper[custMetadataKey]
                }else if(custMetadataType == "DATE_TIME"){
                  let vDT = this.customMapper[custMetadataKey]
                  if(vDT){
                    this.dateTime = vDT.replace("T", " ")
                  }else{
                    this.dateTime = ""
                  }
                }
                this.editingMetadataKeyInDock = keyName;
                if (custMetadataKey != null && custMetadataType != null){
                  this.editingCustomMetadata = {"_id":custMetadataKey, "type": custMetadataType, "multi_values": custMetadataMultivalue}
                } 
                this.autoFocusInputFields(keyName,custMetadataType);
              },
              autoFocusInputFields(keyName,custMetadataType){
                this.$nextTick(() => {
                if(Object.prototype.toString.call(this.$refs[keyName]) == '[object Array]'){
                  if(["DATE","DATE_TIME"].includes(custMetadataType)){
                    setTimeout(() => {
                      this.$refs[keyName][1].focus();
                    }, 200);
                  }else if(this.$refs[keyName].length > 0 && this.$refs[keyName][1].$el != undefined){
                    setTimeout(() => {
                      this.$refs[keyName][1].$el.focus();
                    }, 200);
                  }else if(this.$refs[keyName].length == 0 && this.$refs[keyName][0].$el != undefined){
                    setTimeout(() => {
                      this.$refs[keyName][0].$el.focus();
                    }, 200);
                  }else{
                    this.$refs[keyName][1].focus();
                  }
                }else if(Object.prototype.toString.call(this.$refs[keyName]) == '[object Object]'){
                  if(this.$refs[keyName].$el != undefined){
                    setTimeout(() => {
                      this.$refs[keyName].$el.focus();
                    }, 200);
                  }else{
                      this.$refs[keyName].focus();
                  }
                }else {
                  if(keyName == 'category'){
                     setTimeout(() => {
                        this.$refs.catalogMultiPicklist.$el.firstElementChild.firstElementChild.focus();
                      }, 200);
                  }else{
                      setTimeout(() => {
                        this.$refs[keyName].focus();
                      }, 200);
                    }
                }
                });
              },
          cancelMetadataDockFields(field) {
            this.editingMetadataKeyInDock = null;
            this.editingCustomMetadata = {};
            this.categoryListFromAutocomplete = [];
            this.postData.cutomMetadatavalue = "";
            if(this.assetUpdatedThroughNotification){
              if ("asset_state" in this.assetDetails){
                this.updateMetadataOfAssetsThroughNotification(this.assetDetails._id);
              }else{
                this.updateMetadataOfFilesThroughNotification(this.assetDetails.file_uid);
              }
              this.assetUpdatedThroughNotification = false
            }
            if(field == 'tags'){
              this.getTagIds();
            }else if(field == 'category'){
              this.selectedCatParentIdList = this.assetDetails[this.postcatalogKey]
            }
          },
          getDescription(){
            if ("metadata" in this.assetDetails && this.assetDetails.metadata.description != null){
              return this.assetDetails.metadata.description
            }
            return ""
          },
          getTagIdList(tags){
            let temp = [];
            for(let t = 0; t< tags.length; t++){
              temp.push(tags[t]._id)
            }
            return temp;
          },
          setController(controller){
                  this.controller = controller
              },
              showActionsOnPlayer(){
                  this.actionsOnPlayer = ! this.actionsOnPlayer;
              },
              maximisePlayer(){
                  this.$emit("maximisePlayer");
              },
              closeMiniPlayer(){
                  this.$emit("closeMiniPlayer")
              },
              getThumbnailPath(file){
                return Utils.getThumbnailPathfromFileInfo(file)
              },
              getLowresPath(file){
                return Utils.getLowresPathfromFileInfo(file)
              },
              getAudiowaveform(file){
                  return Utils.getAudiowaveformFromFileInfo(file)
              },
              getUnique(array){
              var uniqueArray = [];
              
              // Loop through array values
              for(let i=0; i < array.length; i++){
                  if(uniqueArray.indexOf(array[i]) === -1) {
                      uniqueArray.push(array[i]);
                  }
              }
              return uniqueArray;
              },
              saveFields(field, isMandatoryField){
                let payload = {};
                let state = "";
                if ("asset_state" in this.assetDetails){
                  payload._id = this.assetDetails._id
                  state = this.assetDetails.asset_state
                }else{
                  payload._id = this.assetDetails.asset_id
                  state = this.assetDetails.state
                }
                  if(field == "slug_name"){
                    if(typeof this.postData[field] == "undefined" || this.postData[field].trim().length <= 0){
                      alert("Media slug can not be empty. Please add valid media slug.")
                      return;
                    }
                    payload[field] = this.postData[field]
                  }
                  if(field == this.postcatalogKey){
                    payload[field] = this.selectedCatParentIdList;
                  }
                  else if(field == "description"){
                    let metadata = {}
                    metadata[field] = this.postData.metadata[field]
                    payload["metadata"] = metadata
                  }
                  else if(field == "Project"){
                      if(!this.selectedDepartments || Object.keys(this.selectedDepartments).length == 0){ 
                        alert(this.globalSettingsFromStartup.department_alias &&  this.globalSettingsFromStartup.department_alias.alias_name?"Please select " +this.globalSettingsFromStartup.department_alias.alias_name:"Please select Department")
                        return;
                      }
                      payload["department_id"]  = this.selectedDepartments._id;
                  }
                  else if(field == "RefID"){
                      payload["reference_id"]  = this.referenceID;
                  }
                  else if(field == "tags"){
                      // payload["metadata"]  = {"tag_ids":this.getUnique(this.selectedTagIdList)}
                      payload["metadata"]  = {"tag_ids":this.getTagIdList(this.selectedTags)}
                  }
                  else if(field == "custom_metadata"){
                    this.customMetadataCheck = [];
                    if (Object.keys(this.editingCustomMetadata).length != 0){
                      if(["DATE"].includes(this.editingCustomMetadata.type)){
                        if(this.time1 == null){
                          this.customMetadataCheck = []
                          this.customMapper[this.editingCustomMetadata._id] = ""
                        }else if(this.time1.trim()){
                          this.customMetadataCheck = [this.time1];
                          this.customMapper[this.editingCustomMetadata._id] = this.time1
                        }
                      }else if(["DATE_TIME"].includes(this.editingCustomMetadata.type)){
                        if(this.dateTime == null){
                          this.customMetadataCheck = [];
                          this.customMapper[this.editingCustomMetadata._id] = ""
                        }else{
                          let rDT = this.dateTime;
                          rDT = rDT.replace(" ","T");
                          this.customMetadataCheck = [rDT];
                          this.customMapper[this.editingCustomMetadata._id] = rDT
                        }
                        this.customMapper[this.editingCustomMetadata._id] = this.time1
                      }else if(['INTEGER','FREETEXT','FREETEXT_MULTILINE'].includes(this.editingCustomMetadata.type)){
                        if(typeof this.customMapper[this.editingCustomMetadata._id] != "undefined" &&
                         this.customMapper[this.editingCustomMetadata._id] != null){
                          this.customMetadataCheck = [this.customMapper[this.editingCustomMetadata._id]];
                         }
                      }else if(this.editingCustomMetadata.type == "PICKLIST"){
                        let valId = this.singlePickListMapper[this.editingCustomMetadata._id].value_id
                        if(valId){
                          this.customMetadataCheck = [valId];
                        }else{
                          this.customMetadataCheck = [];
                        }
                      }else if(this.editingCustomMetadata.type == 'PICKLIST_MULTIVALUE'){
                        if(typeof this.pickListMapper != "undefined" && typeof this.pickListMapper[this.editingCustomMetadata._id] != "undefined"){
                          let vals = this.pickListMapper[this.editingCustomMetadata._id].filter((val)=>val.length != 0);
                          let valList = [];
                          for(let op of vals){
                            valList.push(op.value_id)
                          }
                          this.customMetadataCheck = valList;
                        }
                      }else{
                        this.customMetadataCheck = [this.postData.cutomMetadatavalue];
                      }
                      if ("custom_metadata" in this.assetCustomMetadata){
                          payload["custom_metadata"] = this.assetCustomMetadata.custom_metadata.filter((cmdata)=>cmdata.key_id != this.editingCustomMetadata._id)
                      }else{
                          payload["custom_metadata"] = []
                      }
                      let customKeyValue = {
                          key_id : this.editingCustomMetadata._id,
                          type : this.editingCustomMetadata.type,
                          value: this.customMetadataCheck,
                      }
                      let invalidKeyValue = false
                        if( isMandatoryField){
                          if(customKeyValue.value.length <= 0){
                            invalidKeyValue = true;
                          }else{
                            let valueList = customKeyValue.value;
                            for (let i = 0; i<valueList.length; i++){
                              if(valueList[i] == null || typeof valueList[i] == "undefined" || valueList[i].trim().length <= 0){
                                invalidKeyValue = true;
                                break;
                              }
                            }
                          }
                        }
                        if(invalidKeyValue){
                          let fieldEntry = this.customMetadataList.filter((cmdata)=>cmdata._id == this.editingCustomMetadata._id)[0]
                          if (!confirm(`"${fieldEntry.name}" is mandatory field. Do you want to update with empty value? `)) {
                            return;
                          }
                        }
                        if(this.customMetadataCheck.length){
                          payload.custom_metadata.push(customKeyValue);
                        }
                    }
                  }
                  if (state == "MARK FOR DELETE"){
                    alert("Updating Metadata not available on deleted file(s)")
                    this.categoryListFromAutocomplete = [];
                    if(field == "tags"){
                        this.selectedTags = this.cacheTagIdList;
                    }
                    this.editingCustomMetadata = {}
                    this.showHiddenFields = false;
                  }
                  else{
                  this.updateAssetInfo(payload).then((data)=>{
                      if (data.statusCode==200){
                        this.$emit("updatedDataOfAsset",data)
                        if(field == 'Project' && this.isTypeCatalog){
                          this.updateJobToApplyRecursivly();
                        }
                        if(field == "catalog_id_path"){
                          this.assetDetails[this.postcatalogKey] = this.selectedCatParentIdList;
                        }
                        if(field == "slug_name"){
                          this.slugName = this.postData[field]
                        }else if(field == "description"){
                          this.description = this.postData.metadata[field]
                        }else if(field == "tags"){
                          Object.assign(this.selectedTags,this.assetDetails.tag_info);
                          Object.assign(this.cacheTagIdList,this.selectedTags);
                        }else if(field == 'custom_metadata'){
                            if(["DATE"].includes(this.editingCustomMetadata.type)){
                              if(this.time1 == null){
                                this.customMapper[this.editingCustomMetadata._id] = ""
                              }else if(this.time1.trim()){
                                this.customMapper[this.editingCustomMetadata._id] = this.customMetadataCheck[0]
                              }
                            }else if(["DATE_TIME"].includes(this.editingCustomMetadata.type)){
                              if(this.dateTime != null){
                                this.customMapper[this.editingCustomMetadata._id] = ""
                              }else if(this.dateTime.trim()){
                                this.customMapper[this.editingCustomMetadata._id] = this.customMetadataCheck[0]
                              }
                            }
                          Object.assign(this.assetDetails.custom_metadata,payload.custom_metadata);
                          Object.assign(this.assetCustomMetadata["custom_metadata"], payload.custom_metadata);
                        }
                          this.$toast.success(data.message);
                          this.categoryListFromAutocomplete = [];
                          if(["category_id","tags","custom_metadata"].includes(field)){
                            this.fetchAndLoadRelaventMetadataProfiles(payload.custom_metadata);
                          }
                      }else{
                          this.$toast.error(data.message);
                          this.categoryListFromAutocomplete = [];
                          if(field == "tags"){
                            this.selectedTags = this.cacheTagIdList;
                          }
                      }
                      this.editingCustomMetadata = {}
                      this.showHiddenFields = false;
                })
                }
                this.editingMetadataKeyInDock = null;
                this.editingCustomMetadata = {};
                this.tagNamesList = [];
              },
          closeMetadataManager(){
            this.$emit("close");
          },
          humaniseSize(bytes){
              let data = Utils.humanizeSize(bytes)
              return `${data["value"]} ${data["unit"]}`
          },
          selectCategoryforAnAsset(){
              this.$emit("selectCategoryFromBrowse");
              this.cancelMetadataDockFields()
          },
          getCategoryRoutefromId(){
            return this.route
          },
          getTagNamefromId(tagId){
            if(Object.keys(this.selectedTagIdNameMapper).includes(tagId)){
              return this.selectedTagIdNameMapper[tagId]
            }
            return ''
          },
          openTagsBrowse(){
            this.isTagsBrowse = true;
          },
          closeTagsBrowse(){
            this.isTagsBrowse = false;
          },
          saveTagsSelectedFromBrowse(tags){
            try{
              document.querySelector('.save-cancel-icon.browse-icon.tagsbrowse').focus();
            }catch(e){console.log(e)}
            this.selectedTags = tags;
            this.closeTagsBrowse();
          },
          getSubclipsOfSelectedAssets(assetID,isLoadMore){
            if(!isLoadMore){
              this.subclipsList = [];
            }
            if(!assetID){
              return;
            }
            let payload = {}
              payload.params = {asset_type:"subclip",master_asset_id:assetID,page:this.page,"metadata":"metadata"}
              this.getSubclipsFromServer(payload).then((data) => {
                  this.totalSubclipsPages = data.page_count;
                  if(isLoadMore == true){
                      this.subclipsList = this.subclipsList.concat(data.assets);
                  }else{
                      this.subclipsList = data.assets;
                  }
              })
          },
          loadMoreSubclips(e){
            if(this.subclipsList.length){
              if (e.target.offsetHeight + e.target.scrollTop >= e.target.scrollHeight) {
                      if(this.page < this.totalSubclipsPages){
                        this.page = this.page + 1;
                        if ("asset_id" in this.assetDetails){
                          this.getSubclipsOfSelectedAssets(this.assetDetails.asset_id,true);
                        }else{
                          this.getSubclipsOfSelectedAssets(this.assetDetails._id,true);
                        }
                      }
                      
                  }
            }
          },
          setAssetInfo(info){
            this.assetDetails = {}
            this.singlePickListMapper = {}
            this.pickListMapper = {}
            this.customMapper = {}
            Object.assign(this.assetDetails, info);
            if(this.assetDetails.department_info) {
              this.selectedDepartments = this.assetDetails.department_info;
            }else{
              this.selectedDepartments = null;
            }
            if(this.assetDetails.reference_id) {
              this.referenceID = this.assetDetails.reference_id;
            }else{
              this.referenceID = '';
            }
            if(Object.keys(this.assetDetails).includes("custom_metadata")){
              this.assetCustomMetadata = {"custom_metadata":[]},
              Object.assign(this.assetCustomMetadata["custom_metadata"], this.assetDetails.custom_metadata);
              for(let eachF of info["custom_metadata"]){
                if(eachF.type == "PICKLIST_MULTIVALUE"){
                  let FInfo = [];
                  for(let i of eachF.value){
                    let details = info["field_info"].filter(op=>op.value_id == i)
                    if(details.length > 0){
                      FInfo.push(details[0]);
                    }
                  }
                  this.pickListMapper[eachF.key_id] = FInfo;
                }else if(eachF.type == "PICKLIST"){
                  let details = info["field_info"].filter(op=>op.value_id == eachF.value[0])
                  if(details.length > 0){
                    this.singlePickListMapper[eachF.key_id] = details[0];
                  }
                }else{
                  this.customMapper[eachF.key_id] = eachF.value[0];
                }
              }
            }else{
              this.assetDetails["custom_metadata"] = [];
            }
            if(this.assetDetails.slug_name != undefined){
              this.slugName = `${this.assetDetails.slug_name}`
              this.postData.slug_name = `${this.assetDetails.slug_name}`  
            }
            if(Object.keys(this.assetDetails).includes("catalog_path") || Object.keys(this.assetDetails).includes("parent_path")){
              if (Object.keys(this.assetDetails).includes("catalog_path")){
                if(this.assetDetails.catalog_path.length > 0){
                  this.selectedCatParentIdPathList = this.assetDetails.catalog_path;
                  this.selectedCatParentIdList = this.assetDetails.catalog_id_path;
                  this.postcatalogKey = "catalog_id_path"
                }
              }else {
                if(this.assetDetails.parent_path.length > 0){
                  this.selectedCatParentIdPathList = this.assetDetails.parent_path;
                  this.selectedCatParentIdList = this.assetDetails.parent_id_path;
                  this.postcatalogKey = "parent_id_path"
                }
              }
              if(this.selectedCatParentIdPathList.length > 0)this.selectedCatParentIdPathList = this.selectedCatParentIdPathList.filter(e => e._id != "0");
              if(this.selectedCatParentIdList.length > 0)this.selectedCatParentIdList = this.selectedCatParentIdList.filter(e => e != "catalog_id://0");
              if(this.selectedCatParentIdPathList.length > 0){
                this.route = this.selectedCatParentIdPathList[0]
              }
              this.fetchAndLoadRelaventMetadataProfiles(this.assetDetails["custom_metadata"]);
            }
            this.description = `${this.getDescription()}`
            this.postData.metadata.description = `${this.getDescription()}`
            this.isLoaded=true 
            this.getTagIds();
            if ("asset_id" in this.assetDetails){
              this.getSubclipsOfSelectedAssets(this.assetDetails.asset_id,false);
            }else{
              this.getSubclipsOfSelectedAssets(this.assetDetails._id,false);
            }
            if (this.assetDetails.mime_type != undefined && this.assetDetails.mime_type.startsWith("video")){
                this.videoOptions.sources.push({
                      src:this.getLowresPath(this.assetDetails),
                      type: "video/mp4"
                  })
            }else if (this.assetDetails.mime_type != undefined && this.assetDetails.mime_type.startsWith("audio")){
              this.audioUrl = this.getAudiowaveform(this.assetDetails)
            }
          },
          refreshFileInfoAndShowAsset(assetDetails){
            this.setAssetInfo(assetDetails)
          },
          fetchAndLoadRelaventMetadataProfiles(assetFieldEntries){
            // this.showHiddenFields = false;
            this.hiddenFieldIdList = [];
            let profileList = [];
            if(this.metadataProfileList != undefined && this.metadataProfileList.length > 0){
              this.selectedRelaventProfileIdList = [];
              this.checkedProfiles = [];
              this.relevantProfilesList = [];
              for(let ItemS of this.metadataProfileList){
                let isProfileMatched = [];
                if(ItemS.load_when != undefined && ItemS.load_when.length > 0){
                  for(let loadT of ItemS.load_when){
                    if(loadT.type == Constants.loadWhenCatalog){
                      let catIdList = [];
                      if(this.selectedCatParentIdList != undefined && this.selectedCatParentIdList.length > 0){
                        catIdList = this.selectedCatParentIdList;
                      }
                      let iscatIncludes = false;
                      for(let eachCatId of loadT.id_list){
                        if(catIdList.includes(eachCatId)){
                          iscatIncludes = true;
                        }
                      }
                      if(iscatIncludes){
                        isProfileMatched.push(true);
                      }else{
                        isProfileMatched.push(false);
                        break;
                      }
                    }else if(loadT.type == Constants.loadWhenMimeTypes){
                      if((Object.keys(this.assetDetails).includes("mime_type") &&
                         this.assetDetails.mime_type != undefined &&
                         this.assetDetails.mime_type.startsWith(loadT.value)) ||
                          ('asset_type' in this.assetDetails && this.assetDetails.asset_type == "subclip" &&
                           "video" == loadT.value)){
                        isProfileMatched.push(true);
                      }else{
                        isProfileMatched.push(false);
                        break;
                      }
                    }else if(loadT.type == Constants.loadWhenScreenName){
                      if(loadT.id_list.includes(this.tagMetadataScreenId)){
                        isProfileMatched.push(true);
                      }else{
                        isProfileMatched.push(false);
                        break;
                      }
                    }else if(loadT.type == Constants.loadWhenUserName){
                      if(loadT.id_list.includes(this.getLoggedInUserId)){
                        isProfileMatched.push(true);
                      }else{
                        isProfileMatched.push(false);
                        break;
                      }
                    }else if(loadT.type == Constants.loadWhenGroupName){
                      if(Utils.isUserExistsInOneSpecificGroupList(this.getLoggedInUserId, loadT.id_list, this.startupUserGroupList)){
                        isProfileMatched.push(true);
                      }else{
                        isProfileMatched.push(false);
                        break;
                      }
                    }else if(loadT.type == Constants.loadWhenAdvancedExp){
                      //loadWhen Advance exp. matches
                    }else if(this.isFieldType(loadT.type)){
                      for(let fId of loadT.id_list){
                        if(assetFieldEntries == undefined || assetFieldEntries.length <= 0){
                          isProfileMatched.push(false);
                          continue;
                        }
                        let fieldEntryDetails = assetFieldEntries.filter(item=>item.key_id == fId);
                        if(fieldEntryDetails == undefined || fieldEntryDetails.length <= 0){
                          isProfileMatched.push(false);
                          break;
                        }
                        let isFieldValueMatched = false;
                        if(["FREETEXT","FREETEXT_MULTILINE"].includes(loadT.type)){
                          if(loadT.value == fieldEntryDetails[0].value[0]){
                            isFieldValueMatched = true;
                          }
                        }else if(["DATE"].includes(loadT.type)){
                          let fieldDate = fieldEntryDetails[0].value[0];
                          let fromDate = loadT.value[0];
                          let toDate = loadT.value[1];
                          if(fromDate <= fieldDate && fieldDate <= toDate){
                            isFieldValueMatched = true;
                          }
                        }else if(["DATE_TIME"].includes(loadT.type)){
                          let fieldDate = fieldEntryDetails[0].value[0];
                          fieldDate = fieldDate.replace("T"," ");
                          let fromDate = loadT.value[0];
                          fromDate = fromDate.replace("T", " ")
                          let toDate = loadT.value[1];
                          toDate = toDate.replace("T"," ");
                          if(fromDate <= fieldDate && fieldDate <= toDate){
                            isFieldValueMatched = true;
                          }
                        }else if(["INTEGER"].includes(loadT.type)){
                          if(fieldEntryDetails[0].value[0] >= loadT.value["from"] && fieldEntryDetails[0].value[0] <= loadT.value["to"]){
                            isFieldValueMatched = true;
                          }
                        }else if(["PICKLIST","PICKLIST_MULTIVALUE"].includes(loadT.type)){
                          for(let val of loadT.value){
                            if(!fieldEntryDetails[0].value.includes(val)){
                              isFieldValueMatched = false;
                              break;
                            }
                            isFieldValueMatched = true;
                          }
                        }
                        if(isFieldValueMatched){
                          isProfileMatched.push(true);
                        }else{
                          isProfileMatched.push(false);
                          break;
                        }
                      }
                    }
                  }
                  if(isProfileMatched.includes(false)){
                    if(this.selectedRelaventProfileIdList != undefined &&
                      this.selectedRelaventProfileIdList.includes(ItemS._id)){
                      this.selectedRelaventProfileIdList.splice(this.selectedRelaventProfileIdList.indexOf(ItemS._id), 1)
                      this.checkedProfiles = this.checkedProfiles.filter(item => item.metadata_profile_id != ItemS._id)
                    }
                  }else if(isProfileMatched.length > 0){
                    profileList.push({
                      "metadata_profile_id":ItemS._id,
                      "name":ItemS.name
                    })
                    this.selectedRelaventProfileIdList.push(ItemS._id);
                  }
                }else if(!this.selectedRelaventProfileIdList.includes(ItemS._id)){
                  profileList.push({
                    "metadata_profile_id":ItemS._id,
                    "name":ItemS.name
                  })
                  this.selectedRelaventProfileIdList.push(ItemS._id);
                }
              }
              if(this.selectedRelaventProfileIdList == undefined ||
               this.selectedRelaventProfileIdList.length <= 0 ||
                this.showHiddenFields){
                this.selectedRelaventProfileIdList.push('All');
              }
              this.checkedProfiles = profileList;
              this.relevantProfilesList = profileList;
              // this.relevantProfilesList.push({"metadata_profile_id":"All","name":"All"});
            }
            this.updateFieldsView();
          },
          isFieldType(fieldType){
            return ["FREETEXT","FREETEXT_MULTILINE","DATE","DATE_TIME","INTEGER","PICKLIST","PICKLIST_MULTIVALUE"].includes(fieldType);
          },
          reloadJobDetails(){
              let payload = {}
              payload.params = {jobId:this.jobId}
              this.getJobInfoFromServer(payload).then((data)=>{
                  let job = data.job;
                  this.$toast.info("Reloaded !")
                  this.updateStatusDetails(job.status_info);
                  this.errorMessage = job.error_message;
                  if(["COMPLETED","IN_PROGRESS",'QUEUED'].includes(job.state)){
                      this.isJobFailed = false;
                  }
                  else{
                      this.isJobFailed = true;
                  }
              })
          },
          updateJobToApplyRecursivly(){
            this.isJobCompleted = false;
            this.isJobFailed = false;
            this.isJobInitialted = false;
            this.showLoadingGif = true;
            let payload = {
                "update_type": "catalog",
                "catalog_id": this.assetDetailsFromParent._id,
                "update_data": [
                    {
                        "action": "Replace all with",
                        "type": "department_id",
                        "value": this.selectedDepartments._id
                    }
                ],
                "job_name": "Bulk Field Update",
                "element_type": "assets"
            };
            
            this.createNewJob(payload).then((data) => {
              if (data.statusCode == 200) {
                this.$toast.success(data.message);
                this.jobId = data.job_id;
              } else {
                this.isJobFailed = true;
                this.showLoadingGif = false;
                this.errorMessage = data.message;
                this.$toast.error(data.message);
              }
            })
          },
          reloadRelaventProfileList(catalogId){
            let loadAll = true;
            if(typeof catalogId != "undefined" || catalogId.length > 0){
              loadAll = false;
            }
            if(loadAll){
              let idList = this.customMetadataList;
              for(let i=0; i<idList.length; i++){
                if(this.displayAlwaysFieldsIdList.indexOf(idList[i]._id) == -1){
                  this.displayAlwaysFieldsIdList.push(idList[i]._id)
                }
              }
            }
          },
           refreshStartData(keyName){
            if(keyName == "user_groups" && Object.keys(this.getStartUpDataFromInCache()).includes("user_groups")){
              this.startupUserGroupList = this.getStartUpDataFromInCache()["user_groups"];
            }else if(keyName == "custom_metadatas" && Object.keys(this.getStartUpDataFromInCache()).includes("custom_metadatas")){
              this.customMetadataList = this.getStartUpDataFromInCache()["custom_metadatas"];
            }else if(keyName == "metadata_profiles" && Object.keys(this.getStartUpDataFromInCache()).includes("metadata_profiles")){
              let enableProfiles = true;
              if('screen_profile_required' in this.getStartUpDataFromInCache() &&
                 !this.getStartUpDataFromInCache()["screen_profile_required"]){
                enableProfiles = false;
              }
              if(enableProfiles){
                this.metadataProfileList = this.getStartUpDataFromInCache()["metadata_profiles"];
              }
            }else if(keyName == "screens" && Object.keys(this.getStartUpDataFromInCache()).includes("screens")){
              let screenExists = false;
              let screens = this.getStartUpDataFromInCache()["screens"];
              if(screens.length > 0){
                let screensList = [];
                  if(this.isSubclipEnabled){
                    screensList = screens.filter((a)=>a.name == 'Subclip')
                  }else{
                    screensList = screens.filter((a)=>a.name == this.screenType)
                  }
                if(screensList.length > 0){
                  screenExists = true;
                  let screenDetails = screensList[0];
                  this.metadataScreenInfo = JSON.parse(JSON.stringify(screenDetails));
                  this.tagMetadataScreenId = screenDetails._id;
                  let displayAlwaysList = screenDetails.display_always_field_id_list;
                  if(typeof displayAlwaysList != "undefined" && displayAlwaysList.length > 0){
                      Object.assign(this.displayAlwaysFieldsIdList, displayAlwaysList);
                      Object.assign(this.fetchedFieldIdList, this.displayAlwaysFieldsIdList);
                  }
                }
              }
              if(!screenExists){
                for(let eachDict of this.customMetadataList){
                  if(!this.metadataScreenInfo.field_id_list.includes(eachDict._id)){
                    this.metadataScreenInfo.field_id_list.push(eachDict._id);
                  }
                }
              }
            }
          },
          updateMetadataOfAssetsThroughNotification(fileId){
            let payload = {}
              payload.params = {assetId: fileId}
              this.getAssetInfoFromServer(payload).then((data) => {
                let info  = data["asset"];
                info["catalog_id_path"] = info["parent_id_path"];
                info["catalog_path"] = info["parent_path"];
                this.setAssetInfo(info)
              })
          },
          updateMetadataOfFilesThroughNotification(fileId){
            let payload = {}
              payload.params = {fileId: fileId, metadata:true}
              this.getFileInfoFromServer(payload).then((data) => {
                  this.setAssetInfo(data["file"])
              })
          },
          handleBulkMetadataNotification(notification){
            notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
              if(notification.message){
                  let mssgInfo = notification.message;
                  if(mssgInfo.job_id == this.jobId){
                      if(mssgInfo.state == 'COMPLETED'){
                        this.isJobInitialted = false;
                        this.isJobFailed = false;
                        this.showLoadingGif = false;
                      }else if(mssgInfo.state == 'FAILED'){
                        this.isJobFailed = true;
                        this.isJobCompleted = false;
                        this.showLoadingGif = false;
                      }{
                        this.isJobInitialted = true;
                        this.showLoadingGif = false;
                        this.isJobCompleted = false;
                        this.isJobFailed = false;
                      }
                      this.updateStatusDetails(mssgInfo.status_info);
                  }
              }
          },
          updateStatusDetails(statusDetails){
                if(typeof statusDetails != "undefined" &&
                    Object.keys(statusDetails).includes("progress")){
                    this.progressValue = statusDetails["progress"];
                    if(Object.keys(statusDetails).includes("total_assets_count")){
                        this.totalAssetsCount = statusDetails["total_assets_count"];
                    }else{
                        this.totalAssetsCount = 0;
                    }
                    if(Object.keys(statusDetails).includes("updated_assets_count")){
                        this.updatedAssetsCount = statusDetails["updated_assets_count"];
                        this.totalAssetsCount = statusDetails["total_assets_count"];
                    }else{
                        this.updatedAssetsCount = 0;
                    }
                    if(statusDetails["progress"] == 100){
                        if(!this.isJobCompleted){
                            this.isJobCompleted = true;
                            this.isJobInitialted = false;
                            this.isJobFailed = false;
                        }
                    }
                }
              },
          handleNotifications(notification){
            notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
            if(notification.message){
                let entry_info = notification.message
                if(notification.message_type == NotifierConstants.screenModifiedNotification){
                  if(this.tagMetadataScreenId == entry_info.screen_id){
                    setTimeout(()=>{
                      this.refreshStartData("screens");
                      this.refreshStartData("user_groups");
                      if(!(this.editingMetadataKeyInDock != null && this.editMetadataDockFields.length > 0)){
                        this.fetchAndLoadRelaventMetadataProfiles(this.assetDetails["custom_metadata"]);
                      }
                    },100);
                  }
                 }else if([NotifierConstants.fieldCreatedNotification].includes(notification.message_type)){
                            setTimeout(()=>{
                              this.refreshStartData("custom_metadatas");
                              if(!(this.editingMetadataKeyInDock != null && this.editMetadataDockFields.length > 0)){
                                this.fetchAndLoadRelaventMetadataProfiles(this.assetDetails["custom_metadata"]);
                              }
                            }, 100);
                }else if([NotifierConstants.fieldModifiedNotification,
                          NotifierConstants.fieldRemovedNotification].includes(notification.message_type)){
                            setTimeout(()=>{
                              this.refreshStartData("custom_metadatas");
                              if(!(this.editingMetadataKeyInDock != null && this.editMetadataDockFields.length > 0)){
                                this.fetchAndLoadRelaventMetadataProfiles(this.assetDetails["custom_metadata"]);
                              }
                            }, 100);
                }else if([NotifierConstants.screenProfileCreatedNotification,
                          NotifierConstants.screenProfileModifiedNotification,
                          NotifierConstants.screenProfileRemovedNotification].includes(notification.message_type)){
                          setTimeout(()=>{
                            this.refreshStartData("screens");
                            this.refreshStartData("metadata_profiles");
                            if(!(this.editingMetadataKeyInDock != null && this.editMetadataDockFields.length > 0)){
                                this.fetchAndLoadRelaventMetadataProfiles(this.assetDetails["custom_metadata"]);
                            }
                          },100)
                }else if([NotifierConstants.userGroupCreatedNotification,
                          NotifierConstants.userGroupModifiedNotification,
                          NotifierConstants.userGroupRemovedNotification].includes(notification.message_type)){
                          setTimeout(()=>{
                            this.refreshStartData("user_groups");
                            if(!(this.editingMetadataKeyInDock != null && this.editMetadataDockFields.length > 0)){
                                this.fetchAndLoadRelaventMetadataProfiles(this.assetDetails["custom_metadata"]);
                            }
                          },100)
                }else if(NotifierConstants.userRemovedNotification == notification.message_type){
                  setTimeout(() =>{
                    if(!(this.editingMetadataKeyInDock != null && this.editMetadataDockFields.length > 0)){
                      this.fetchAndLoadRelaventMetadataProfiles(this.assetDetails["custom_metadata"]);
                    }
                  },100);
                }else if(NotifierConstants.assetModifiedNotification == notification.message_type){
                  if(notification.message.master_asset_id == this.assetDetails._id){
                      let sIndex = this.subclipsList.findIndex(e => e.asset_id == notification.message.asset_id);
                      if(sIndex > -1){
                        this.subclipsList[sIndex] = notification.message;
                      }
                  }
                  if ("asset_state" in this.assetDetails){
                    if (this.assetDetails._id == notification.message.asset_id){
                      if(this.editingMetadataKeyInDock == null){
                        this.assetUpdatedThroughNotification = false;
                        this.updateMetadataOfAssetsThroughNotification(this.assetDetails._id);
                      }else{
                        this.assetUpdatedThroughNotification = true;
                      }
                    }
                  }else if(this.assetDetails.asset_id == notification.message.asset_id){
                    if(this.editingMetadataKeyInDock == null){
                      this.assetUpdatedThroughNotification = false;
                      this.updateMetadataOfFilesThroughNotification(this.assetDetails.file_uid);
                    }else{
                      this.assetUpdatedThroughNotification = true;
                    }
                  }
                }else if(NotifierConstants.catalogModifiedNotification == notification.message_type){
                    if(this.categoryDetails._id == notification.message._id){
                      this.$toast.info("Selected catalog is updated by another user");
                      this.categoryDetails = notification.message;
                    }
                }else if(NotifierConstants.catalogRemovedCreatedNotification == notification.message_type){
                      this.$toast.info("Selected catalog is deleted by another user");
                      if(this.categoryDetails._id == notification.message._id){
                        if ("asset_state" in this.assetDetails){
                            this.updateMetadataOfAssetsThroughNotification(this.assetDetails._id);
                        }else{
                            this.updateMetadataOfFilesThroughNotification(this.assetDetails.file_uid);
                        }
                      }
                }else if(NotifierConstants.tagRemovedNotification == notification.message_type){
                      let temp = this.selectedTags.filter(e => e._id == notification.message._id)
                      if (temp.length != 0){
                        this.selectedTags = this.selectedTags.filter(e => e._id != notification.message._id)
                      }
                }else if(NotifierConstants.tagModifiedNotification == notification.message_type){
                      let temp = this.selectedTags.filter(e => e._id == notification.message._id)
                      if (temp.length != 0){
                        temp = temp[0]
                        Object.assign(temp, notification.message)
                      }
                }else if (notification.message_type == NotifierConstants.assetRemovedCreatedNotification){
                      this.subclipsList = this.subclipsList.filter((asset)=>asset._id!=notification.message.asset_id)
                }else if(notification.message_type == NotifierConstants.assetCreatedNotification){
                    let temp = null;
                    if ("asset_id" in this.assetDetails){
                      temp = this.assetDetails.asset_id;
                    }else{
                      temp = this.assetDetails._id;
                    }
                    if(temp == notification.message.master_asset_id){
                      let payload = {}
                      payload.params = {assetId: notification.message.asset_id}
                      this.getAssetInfoFromServer(payload).then((data) => {
                        let info  = data["asset"];
                        info["catalog_id_path"] = info["parent_id_path"];
                        info["catalog_path"] = info["parent_path"];
                        this.subclipsList.push(info);
                      });
                    }
                }
            }
          },
          updateGlobalSettingsValueFromNotification(notification){
              notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification;
              if(Object.keys(notification.message).includes('CATALOG_READ_ONLY')){
                  if(Object.keys(this.getStartUpDataFromInCache()).includes('CATALOG_READ_ONLY')){
                      this.$set(this.getStartUpDataFromInCache(),"CATALOG_READ_ONLY",notification.message.CATALOG_READ_ONLY);
                  }
              }
            },
          ...mapActions("transcript", ["getSubclipTransctiptFromServer"]),
          ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"]),
          ...mapActions("files", ["getFileInfoFromServer"]),
          ...mapActions("tags", ["getTagsOnAutocomplete","getAllTagsFromServer"]),
          ...mapGetters("startUpData",["getStartUpDataFromInCache"]),
          ...mapActions("assets", ["updateAssetInfo","getAssetInfoFromServer","getSubclipsFromServer","getAllAssetsFromServer","deleteSubclip"]),
          ...mapActions("assets",["getCategoryTreefromId","getAutoCompletedAssetsFromServer"]),
          ...mapActions("miscellaneous", ["getDepartments","createDepartment","updateDepartmentInfo","deleteDepartment"]),
          ...mapActions("jobs", ["createNewJob","getJobInfoFromServer"]),
      
    },
    created(){
      

      this.addWSEventListener({
        eventname:[NotifierConstants.screenModifiedNotification,
        NotifierConstants.userRemovedNotification,
        NotifierConstants.userGroupCreatedNotification,NotifierConstants.userGroupModifiedNotification,NotifierConstants.userGroupRemovedNotification,
        NotifierConstants.fieldCreatedNotification, NotifierConstants.fieldModifiedNotification, NotifierConstants.fieldRemovedNotification,
        NotifierConstants.screenProfileCreatedNotification,NotifierConstants.screenProfileModifiedNotification,NotifierConstants.screenProfileRemovedNotification,
        NotifierConstants.assetModifiedNotification,NotifierConstants.catalogModifiedNotification,NotifierConstants.catalogRemovedCreatedNotification,NotifierConstants.tagModifiedNotification,
        NotifierConstants.tagRemovedNotification,NotifierConstants.assetCreatedNotification,NotifierConstants.assetRemovedCreatedNotification],
        callback:this.handleNotifications,
        parent:"TagMetadataComponent"})
        this.addWSEventListener({
          eventname:[NotifierConstants.assetModifiedNotification],
          parent:"RecursiveList"})
    },
    beforeDestroy(){
      this.removeWSEventListener({
              eventname:[NotifierConstants.screenModifiedNotification,
              NotifierConstants.userRemovedNotification,
              NotifierConstants.userGroupCreatedNotification,NotifierConstants.userGroupModifiedNotification,NotifierConstants.userGroupRemovedNotification,
              NotifierConstants.fieldCreatedNotification, NotifierConstants.fieldModifiedNotification, NotifierConstants.fieldRemovedNotification,
              NotifierConstants.screenProfileCreatedNotification,NotifierConstants.screenProfileModifiedNotification,NotifierConstants.screenProfileRemovedNotification,
              NotifierConstants.assetModifiedNotification,NotifierConstants.catalogModifiedNotification,NotifierConstants.catalogRemovedCreatedNotification,NotifierConstants.tagModifiedNotification,
              NotifierConstants.tagRemovedNotification,NotifierConstants.assetCreatedNotification,NotifierConstants.assetRemovedCreatedNotification],
              callback:this.handleNotifications,
              parent:"TagMetadataComponent"})
      this.removeWSEventListener({
        eventname:[NotifierConstants.assetModifiedNotification],
        parent:"RecursiveList"})
    }
}


export default highlightMixin;